import React, { useEffect, useState } from 'react';
import { getFAQDocuments } from '../services/shipturtleApi';
import DataFallback from '../components/feedback/DataFallback';

function getFilename(url) {
  try {
    return decodeURIComponent(url.split('/').pop().split('?')[0]) || 'document.pdf';
  } catch {
    return 'document.pdf';
  }
}

async function triggerDownload(url, filename) {
  try {
    const res = await fetch(url);
    // Guard against 404/500 responses, which would otherwise be saved as a
    // blob (usually an HTML error page). Fall through to the anchor fallback.
    if (!res.ok) throw new Error(`Download failed with status ${res.status}`);
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
  } catch {
    // Fallback: force download via anchor with download attribute
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

function TerminalFAQ() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    getFAQDocuments()
      .then((data) => setDocs(Array.isArray(data) ? data : []))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <p style={{ color: '#666', padding: '1rem 0' }}>Loading…</p>;
  }

  if (error) {
    return (
      <DataFallback
        variant="pane"
        error={typeof error === 'string' ? { message: error, retryable: true } : error}
        onRetry={() => window.location.reload()}
      />
    );
  }

  if (docs.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 0', color: '#9ca3af' }}>
        <div style={{ fontSize: 40, marginBottom: 10 }}>📄</div>
        <p style={{ fontSize: '0.95rem', margin: 0 }}>No documents available yet.</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16, padding: '1rem 0' }}>
      {docs.map((doc) => {
        const filename = doc.title || getFilename(doc.pdf_url);
        return (
          <div
            key={doc.id}
            style={{
              background: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              padding: '20px 16px 16px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 12,
              textAlign: 'center',
            }}
          >
            <div style={{
              width: 52,
              height: 52,
              background: '#fef2f2',
              borderRadius: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 26,
            }}>
              📄
            </div>

            <span style={{ fontWeight: 600, fontSize: '0.88rem', color: '#111827', wordBreak: 'break-word', lineHeight: 1.3 }}>
              {filename}
            </span>

            <div style={{ display: 'flex', gap: 8, width: '100%', marginTop: 'auto' }}>
              <a
                href={doc.pdf_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  flex: 1,
                  padding: '7px 0',
                  background: '#fff',
                  color: '#00bfae',
                  border: '1.5px solid #00bfae',
                  borderRadius: 6,
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textDecoration: 'none',
                  textAlign: 'center',
                }}
              >
                View
              </a>
              <button
                onClick={() => triggerDownload(doc.pdf_url, filename)}
                style={{
                  flex: 1,
                  padding: '7px 0',
                  background: '#00bfae',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 6,
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                Download
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default TerminalFAQ;
